import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ProjectService } from 'src/app/_services/project/project.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-sub-projectform-v2',
  templateUrl: './sub-projectform-v2.component.html',
  styleUrls: ['./sub-projectform-v2.component.scss']
})
export class SubProjectformV2Component implements OnInit {

  projectv2Form: FormGroup;
  tenantId: string;
  currentUser: any;
  currentProjectId: any;
  selectedProject: any;
  userDropdownList = [];
  isPMOLeadORManager: boolean = false;
  isPMOAdmin: boolean = false;
  parentProjectId: any;
  parentProjectName: any;
  projectName: string;
  projectSoftwareName: string;
  activityName: string;
  commodityName: string;
  businessGroupName: string;
  industryName: string;
  regionName: string;
  parentProjectLead: any;
  parentProjectManager: any;

  constructor(
    private router: Router,
    private storageService: LocalStorageService,
    private projectService: ProjectService,
    private route: ActivatedRoute,
    private allocationService: AllocationService,
    private snackBar: MatSnackBar,
  ) {
    this.projectv2Form = new FormGroup({
      id: new FormControl(''),
      projectName: new FormControl(''),
      projectCode: new FormControl(''),
      projectDescription: new FormControl(''),
      projectManagerId: new FormControl(''),
      projectManagerName: new FormControl(''),
      projectLeadId: new FormControl(''),
      projectLeadName: new FormControl(''),
      startDate: new FormControl(''),
      endDate: new FormControl(''),
      decisionDate: new FormControl(''),
      customer: new FormControl(''),
      status: new FormControl(''),
      totalHours: new FormControl(''),
      remainingHours: new FormControl({ value: '', disabled: true }),
      percentageCompleted: new FormControl({ value: '', disabled: true }),
      createdByUserId: new FormControl({ value: '', disabled: true }),
      createdByUserName: new FormControl({ value: '', disabled: true }),
      regionId: new FormControl({ value: '', disabled: true }),
      regionName: new FormControl({ value: '', disabled: true }),
      industryId: new FormControl({ value: '', disabled: true }),
      industryName: new FormControl({ value: '', disabled: true }),
      businessGroupId: new FormControl({ value: '', disabled: true }),
      businessGroupName: new FormControl({ value: '', disabled: true }),
      commodityId: new FormControl({ value: '', disabled: true }),
      commodityName: new FormControl({ value: '', disabled: true }),
      activityId: new FormControl({ value: '', disabled: true }),
      activityName: new FormControl({ value: '', disabled: true }),
      projectSoftwareId: new FormControl({ value: '', disabled: true }),
      projectSoftwareName: new FormControl({ value: '', disabled: true }),
      parentProjectId: new FormControl({ value: '', disabled: true }),
      parentProjectName: new FormControl({ value: '', disabled: true }),
      parentProjectCode: new FormControl({ value: '', disabled: true }),
    });
  }

  // getter for easy access to form fields
  get f() {
    return this.projectv2Form.controls;
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');
    this.parentProjectId = this.route.snapshot.queryParamMap.get('parentId');
    this.isPMOAdmin = this.currentUser.roles.includes('RolePmoAdministrator');
    this.getUserList();
    this.getProjectById();
    if (this.currentProjectId) this.getSubProjectById(this.currentProjectId)
  }

  backToMyProjectV2() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/sub-project-v2'], { queryParams: { projectID: this.parentProjectId } });
  }

  openProjectTab(param) {
    this.router.navigate([this.tenantId + `/dashboard/project/project-list-v2/${param}`], { queryParams: { projectID: this.currentProjectId, parentId: this.parentProjectId } }); // pass current project id as parameter
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      for (let item of response) {
        this.userDropdownList.push(
          `${item.id} . ${item.firstName} ${item.lastName}`
        );
      }
    });
  }

  getSubProjectById(id) {
    this.projectService.getProjectV2(id).subscribe((response: any) => {
      if(response.projectManagerId === this.currentUser.id || response.projectLeadId === this.currentUser.id){
        this.isPMOLeadORManager = true;
      }
      else if(response.parentProjectId){
        if(this.parentProjectManager === this.currentUser.id || this.parentProjectLead === this.currentUser.id){
          this.isPMOLeadORManager = true;
        } 
      }

      this.projectv2Form.patchValue({
        projectName: response.projectName,
        projectCode: response.projectCode,
        projectDescription: response.projectDescription,
        projectManagerName: response.projectManagerId + " . " + response.projectManagerName,
        projectLeadName: response.projectLeadId + " . " + response.projectLeadName,
        startDate: response.startDate,
        endDate: response.endDate,
        decisionDate: response.decisionDate,
        customer: response.customer,
        status: response.status,
        createdByUserName: response.createdByUserId + " . " + response.createdByUserName,
        totalHours: response.totalHours,
        remainingHours: response.remainingHours,
        percentWorkCompleted: response.percentWorkCompleted,
      })
    });
  }

  getProjectById() {
    this.projectService.getProjectV2(this.parentProjectId).subscribe((response: any) => {
      this.parentProjectName = response.id + " . " + response.projectName;
      this.regionName = response.regionId + " . " + response.regionName;
      this.industryName = response.industryId + " . " + response.industryName;
      this.businessGroupName = response.businessGroupId + " . " + response.businessGroupName;
      this.commodityName = response.commodityId + " . " + response.commodityName;
      this.activityName = response.activityId + " . " + response.activityName;
      this.projectSoftwareName = response.projectSoftwareId + " . " + response.projectSoftwareName;
      this.parentProjectLead = response.projectLeadId;
      this.parentProjectManager = response.projectManagerId;

      this.projectv2Form.patchValue({
        parentProjectName: this.parentProjectName,
        regionName: this.regionName,
        industryName: this.industryName,
        businessGroupName: this.businessGroupName,
        commodityName: this.commodityName,
        activityName: this.activityName,
        projectSoftwareName: this.projectSoftwareName
      });
    });
  }

  updateorcreateParametersV2() {
    // if(this.isPMOLeadORManager === true){
    let details: any;
    if (this.projectv2Form.value) {
      details = {
        projectName: this.projectv2Form.get('projectName').value,
        projectCode: this.projectv2Form.get('projectCode').value,
        projectDescription: this.projectv2Form.get('projectDescription').value,
        projectManagerId: parseInt(this.projectv2Form.get('projectManagerName').value.split(' . ')[0]),
        projectLeadId: parseInt(this.projectv2Form.get('projectLeadName').value.split(' . ')[0]),
        startDate: this.projectv2Form.get('startDate').value,
        endDate: this.projectv2Form.get('endDate').value,
        decisionDate: this.projectv2Form.get('decisionDate').value,
        customer: this.projectv2Form.get('customer').value,
        status: this.projectv2Form.get('status').value,
        totalHours: this.projectv2Form.get('totalHours').value,
        regionId: parseInt(this.projectv2Form.get('regionName').value.split(' . ')[0]),
        industryId: parseInt(this.projectv2Form.get('industryName').value.split(' . ')[0]),
        businessGroupId: parseInt(this.projectv2Form.get('businessGroupName').value.split(' . ')[0]),
        commodityId: parseInt(this.projectv2Form.get('commodityName').value.split(' . ')[0]),
        activityId: parseInt(this.projectv2Form.get('activityName').value.split(' . ')[0]),
        projectSoftwareId: parseInt(this.projectv2Form.get('projectSoftwareName').value.split(' . ')[0]),
        parentProjectId: parseInt(this.projectv2Form.get('parentProjectName').value.split(' . ')[0]),
      }
    }
    
    if (this.currentProjectId) {
      this.projectService.updateProjectV2(this.currentProjectId, details).subscribe(response => {
        this.backToMyProjectV2()
      }, error => {
        this.openSnackBar('ERROR: cannot update project: ' + error);
      });
    } else {
      this.projectService.createProjectV2(details).subscribe((response: any) => {
        this.backToMyProjectV2();
      }, error => {
        this.openSnackBar('ERROR: cannot create project: ' + error);
      });
    }
  }
}